/* ============================================================
   HAPU FAQ ACCORDION — add this inside your DOMContentLoaded
   listener in theme.js
   ============================================================ */

(function () {
  const faqWraps = document.querySelectorAll('.hapu-faq-wrap');

  faqWraps.forEach(function (wrap) {
    const items      = wrap.querySelectorAll('.hapu-faq-item');
    const expandBtn  = wrap.querySelector('.hapu-expand-btn');

    function openItem(item) {
      item.classList.add('hapu-open');
      item.querySelector('.hapu-faq-question').setAttribute('aria-expanded', 'true');
    }

    function closeItem(item) {
      item.classList.remove('hapu-open');
      item.querySelector('.hapu-faq-question').setAttribute('aria-expanded', 'false');
    }

    function allOpen() {
      return Array.from(items).every(function (i) {
        return i.classList.contains('hapu-open');
      });
    }

    function syncExpandBtn() {
      if (!expandBtn) return;
      if (allOpen()) {
        expandBtn.classList.add('hapu-all-open');
        expandBtn.childNodes[0].textContent = 'Collapse all ';
      } else {
        expandBtn.classList.remove('hapu-all-open');
        expandBtn.childNodes[0].textContent = 'Expand all ';
      }
    }

    // Individual toggle
    items.forEach(function (item) {
      item.querySelector('.hapu-faq-question').addEventListener('click', function () {
        if (item.classList.contains('hapu-open')) {
          closeItem(item);
        } else {
          openItem(item);
        }
        syncExpandBtn();
      });
    });

    // Expand / collapse all
    if (expandBtn) {
      expandBtn.addEventListener('click', function () {
        if (allOpen()) {
          items.forEach(closeItem);
        } else {
          items.forEach(openItem);
        }
        syncExpandBtn();
      });
    }

    syncExpandBtn();
  });
})();